import { render } from "./bulk-operations.vue?vue&type=template&id=697c833c&scoped=true"
import script from "./bulk-operations.vue?vue&type=script&lang=js"
export * from "./bulk-operations.vue?vue&type=script&lang=js"

import "./bulk-operations.vue?vue&type=style&index=0&id=697c833c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697c833c"]])

export default __exports__